export default __webpack_public_path__ + "static/media/zoom.297e5279.webp";